import { componentName as groupComponentName, RadioGroupClass } from './RadioGroupClass';
import { componentName as buttonComponentName, RadioButtonClass } from './RadioButtonClass';
import '@vaadin/radio-group';

customElements.define(groupComponentName, RadioGroupClass);
customElements.define(buttonComponentName, RadioButtonClass);

export { RadioGroupClass, groupComponentName as componentName };
